<app-products-header-banner></app-products-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center">
  <h2 class="font-bold text-3xl website-heading">Varroc Connect Cloud</h2>
  <span class="font-light text-2xl website-light-heading">How It Works</span>
  <span class="text-l text-justify w-full  mt-5 website-default-margin ">Varroc Connect Cloud is a data center linking
    Varroc devices and unified Apps, granting users remote access to vehicle data. It centralizes storage and processing
    of diagnostic, location, and driving behavior information for easy management and analysis.</span>
  <img [src]="Images.HIERARCHY_1" alt="Varroc Connect Cloud-Based Solutions" class="w-full md:w-4/5 mt-10">
</div>

<div
  class="tabs-container self-center border-[#dbdbdb] flex justify-center gap-5 mt-5 md:mt-20 w-full lg:w-full max-w-full overflow-x-auto md:overflow-x-hidden overflow-y-hidden whitespace-nowrap px-5">
  <ul class="tabs text-xl md:w-[82%]">
    <li (click)="showCarIQCloud(0)" class="md:flex-1" [class.active]="cloudToShow === 0">
      <div class="flex items-center gap-2 justify-center ">
        <span class="text-lg">VC Auto Cloud</span>
      </div>
    </li>
    <li (click)="showCarIQCloud(1)" class="md:flex-1" [class.active]="cloudToShow === 1">
      <div class="flex items-center gap-2 justify-center">
        <span class="text-lg">VC
          Insurance Cloud</span>
      </div>
    </li>
    <li (click)="showCarIQCloud(2)" class="md:flex-1" [class.active]="cloudToShow === 2">
      <div class="flex items-center gap-2 justify-center">
        <span class="text-lg">VC
          TLS Cloud</span>
      </div>
    </li>
  </ul>
</div>

<div *ngIf="cloudToShow==0"
  class="container mx-auto mt-16 px-5 w-11/12 flex flex-col justify-center items-center gap-3">
  <h2 class="font-bold text-3xl website-heading">Varroc Connect Auto Cloud</h2>
  <span class="font-light text-2xl website-light-heading">Manage, Update and Analyze Connected Vehicles</span>
  <span class="text-l text-[#0A0A0A] text-justify w-full mt-5">The evolution of new technology in the automotive
    industry is transforming vehicle maintenance, software updates, and remote upgrades. In the past, vehicle software
    updates were lengthy processes that involved additional travel costs and significant time investments. To address
    this, Varroc Connect offers a solution that transforms vehicles into advanced operating systems, similar to
    computers or smartphones, enabling automotive OEMs to seamlessly manage both customers and vehicles on a single
    platform. With our mature platform, you can easily manage, update, and analyze your connected vehicles.</span>


  <div class="flex gap-6 md:flex-row flex-col mt-5">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_OBD" alt="Targeted Device Update and Configuration Icon" class="size-10">
      <span>Ability to select specific criteria for delivering updates and configurations to targeted devices or
        vehicles</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_REFRESH" alt="Continuous Updates for Latest Features Icon" class="size-10">
      <span>Ensure users always have access to the latest features and bug fixes through continuous updates</span>
    </div>
  </div>

  <div class="flex gap-6 md:flex-row flex-col mt-5">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_SETTING" alt="OTA Software Update and Device Configuration Icon" class="size-10">
      <span>Update software and configure devices seamlessly through over-the-air (OTA) updates</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_ANALYTICS" alt="Real-Time Campaign Update Analytics Icon" class="size-10">
      <span>Monitor campaign (software/firmware) update status in real time.</span>
    </div>
  </div>

  <div class="flex gap-6 md:flex-row flex-col mt-5">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_WATCH" alt="Real-Time and Historical Data Access Icon" class="size-10">
      <span>Access real-time and historical data by downloading task logs.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_TRUCK" alt="Fleet Management Insights and Reports Icon" class="size-10">
      <span>Fleet Management: Real-time insights, detailed reports, and optimized operations.</span>
    </div>
  </div>

  <div class="flex gap-6 md:flex-row flex-col mt-5">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_CAR" alt="OEM Vehicle User and Device Management Icon" class="size-10">
      <span>User Addition & Device Management: OEMs can easily add new users and vehicles to the platform, enabling
        seamless scalability.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_SIGNAL" alt="Telecom Management Platform Icon" class="size-10">
      <span>Telecom Management: Streamline and manage all telecommunication needs from a single platform.</span>
    </div>
  </div>

  <div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center">
    <img [src]="Images.OTA" alt="Varroc Connect Over-the-Air (OTA) Update Feature" class="w-full md:w-[50%] mt-10">

    <span class="font-bold text-3xl website-heading">Over-the-Air Updates</span>
    <span class="text-l text-justify w-full  mt-5 website-default-margin ">Varroc Connect offers over-the-air (OTA)
      updates for both software and firmware, ensuring vehicles receive timely enhancements and fixes remotely. Software
      OTA updates provide a cost-effective way to address security or functional issues without physical intervention.
      Previously, updating devices or vehicles required users to visit authorized service centers. However, with
      innovation, OTA updates can now be delivered wirelessly via networks such as Wi-Fi or cellular. <br> In vehicles,
      the Telematics Control Unit
      (TCU) plays a pivotal role by facilitating communication between the vehicle and the server during updates. It
      manages protocols such as TCP, HTTP, and MQTT, which are essential to ensure seamless initiation and completion of
      the update process.
      With the Varroc Connect Auto Cloud Platform, OEMs can efficiently deliver OTA updates to individual vehicles or
      specific groups.</span>
  </div>

  <img [src]="Images.HIERARCHY_2" alt="Varroc Connect Cloud Solutions Hierarchy Diagram" class="w-full md:w-4/5">


</div>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center"
  *ngIf="cloudToShow==1">
  <h2 class="font-bold text-3xl website-heading">Varroc Connect Insurance Cloud</h2>
  <span class="font-light text-2xl website-light-heading">Streamline, Analyze and Insure</span>
  <span class="text-l text-justify w-full  "> Through our cloud-based platform, we
    streamline operations by handling insurers' data analytics. We enable insurers to provide their customers with a
    personalized experience. Policyholders can benefit from self-service options such as claim filing and managing their
    product requirements through our platform. By automating repetitive tasks, our solution enhances efficiency and
    reduces errors, ensuring streamlined processes across the insurance ecosystem. The insurance sector is embracing
    telematics, driven by demand for usage-based insurance that enhances customer experience and boosts revenue.
    Telematics-based insurance profitability hinges on leveraging detailed vehicle data. While dongles or devices
    typically restrict the scope for offering insurance add-ons, our cloud platform and application empower insurers to
    effectively manage risk. This enables them to tailor personalized and competitive premiums based on driver usage and
    behavior. Our cloud-based platform can be leveraged by any financial service dealing with vehicles. </span>
  <img [src]="Images.INSURANCE_CLOUD" alt="" class="w-full md:w-[30%]">
</div>

<div *ngIf="cloudToShow==2"
  class="container mx-auto mt-16 px-5 w-11/12 flex flex-col justify-center items-center gap-3">

  <!-- Heading -->
  <h2 class="font-bold text-3xl website-heading text-center">Varroc Connect Transport, Logistics, and Supply Chain
    Cloud</h2>
  <span class="font-light text-2xl website-light-heading text-center">Smarter saving with optimized delivery</span>
  <span class="text-l text-gray-600 text-justify w-full mt-5">
    In today's fast-paced business environment, optimizing both delivery speed and cost efficiency is crucial.
    Our solution is the archetype in fleet management, providing the transparency and insights needed to excel
    in today's competitive landscape.
  </span>

  <!-- Row 1 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_TRUCK" alt="" class="size-10">
      <span>Immediate access to accurate data on your entire fleet.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_SETTING" alt="" class="size-10">
      <span>AI and machine learning turn vehicle data into actionable insights.</span>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_FUEL" alt="" class="size-10">
      <span>Monitor fuel efficiency to control costs.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_ZOOM" alt="" class="size-10">
      <span>Track vehicles in real-time</span>
    </div>
  </div>

  <!-- Row 3 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_ANALYTICS" alt="" class="size-10">
      <span>Generate various analytic reports</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_WATCH" alt="" class="size-10">
      <span>Optimize routes for maximum efficiency.</span>
    </div>
  </div>

  <!-- Diagram -->
  <img [src]="Images.HIERARCHY_2" alt="" class="w-full md:w-4/5 mt-10">
</div>